import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownWidth,
} from '@core/user-interface-legacy';

import { TimeZonePickerDropdownListComponent } from '../time-zone-picker-dropdown-list/time-zone-picker-dropdown-list.component';

@Component({
  selector: 'rt-time-zone-picker-dropdown',
  templateUrl: 'time-zone-picker-dropdown.component.html',
  styleUrls: ['./time-zone-picker-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    TimeZonePickerDropdownListComponent,
    TranslatePipe,
  ],
})
export class TimeZonePickerDropdownComponent {
  public close = output<void>();
  public zoneSelect = output<string>();

  public DropdownWidth = DropdownWidth;
}
